import { createContext, useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { adminApi } from "@/admin/api";

const AdminAuthContext = createContext(null);

export const useAdminAuth = () => useContext(AdminAuthContext);

// user: null = checking session, false = not authenticated, object = authenticated
export const AdminAuthProvider = () => {
  const [user, setUser] = useState(null);

  // Back-office : jamais indexé par les moteurs (complète le Disallow /admin du robots.txt)
  useEffect(() => {
    let m = document.head.querySelector('meta[name="robots"]');
    if (!m) {
      m = document.createElement("meta");
      m.setAttribute("name", "robots");
      document.head.appendChild(m);
    }
    m.setAttribute("content", "noindex, nofollow");
    return () => m.remove();
  }, []);

  useEffect(() => {
    adminApi
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await adminApi.post("/auth/logout");
    } catch (e) {
      // ignore
    }
    setUser(false);
  };

  return (
    <AdminAuthContext.Provider value={{ user, login, logout }}>
      <Outlet />
    </AdminAuthContext.Provider>
  );
};
